/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  'arrow-down-bold': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9 4h6v8h4.839L12 19.839 4.161 12H9V4z"/>'
  }
});
